/*
 *---------------------------------------------------
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *---------------------------------------------------
 */
export const FETCH_ORDER_DETAILS = "FETCH_ORDER_DETAILS";
export const FETCH_ORDER_DETAILS_SUCCESS = "FETCH_ORDER_DETAILS_SUCCESS";
export const FETCH_RCU_ORDER_DETAILS_SUCCESS = "FETCH_RCU_ORDER_DETAILS_SUCCESS";
export const FETCH_ORDER_DETAILS_FAIL = "FETCH_ORDER_DETAILS_FAIL";
export const FETCH_ORDER_ITEMS_SUCCESS = "FETCH_ORDER_ITEMS_SUCCESS";
export const FETCH_ORDER_ITEMS_FAIL = "FETCH_ORDER_ITEMS_FAIL";
